export const percentageFormatter = Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 2,
});

export const percentageFormatterNoDecimal = Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 0,
});

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export const currencyFormatterNoCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const numericFormatter = new Intl.NumberFormat('en-US');

/**
 * Uppercase just the first letter of the given string
 */
export const toUppercase = (value: string, entireString = false) => {
  if (value === null || value === undefined) {
    return value;
  }

  const locale = navigator.language;

  if (entireString) {
    return value.toLocaleUpperCase(locale);
  }

  return value.charAt(0).toLocaleUpperCase(locale) + value.slice(1).toLocaleLowerCase(locale);
};

export const centsToDollars = (cents: number, withCents = true) => {
  return `${(withCents ? currencyFormatter : currencyFormatterNoCents).format(cents / 100)}`;
};
